function ShippingPage() {
    return (
      <div className="bg-custom-ivory text-custom-maroon min-h-screen py-10 px-6">
        <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold mb-4 border-b-4 border-custom-yellow pb-2">Shipping Information</h1>
          <p className="text-lg mt-4">
            Thank you for visiting our website. Please note that we are a consultancy service dedicated to providing expert advice and guidance. 
            As such, we do not sell or ship any physical products. If you have any questions or require further assistance, feel free to 
            contact us using the details on our <a href="/contact_us" className="text-custom-yellow-dark font-semibold">Contact Us</a> page.
          </p>
        </div>
      </div>
    );
  }
  
  export default ShippingPage;
  